import { reportsApi } from 'Reports/service/reports.api';
import { ReportBasePage } from '../../Reports/components/ReportBasePage';
import { ReportPageTypes } from '../../Reports/model/ReportPageTypes';

export const StatusOfCertificationsPage = () => (
  <ReportBasePage
    reportType={ReportPageTypes.StatusOfCertifications}
    reportApi={reportsApi.getFilterCertificationPlans}
    reportToFileApi={reportsApi.getFilterCertificationPlansToFile}
  />
);
